export function ExclamationCircleStatusIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect width='20' height='20' rx='10' fill='currentColor' />
      <path
        d='M10 7.33333V10M10 12.6667H10.0067M16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10Z'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
